import { cameraModelsSelector } from 'selectors'
import { select } from 'redux-saga/effects'
import pipe from 'ramda/src/pipe'
import defaultTo from 'ramda/src/defaultTo'
import replace from 'ramda/src/replace'
import isEmpty from 'ramda/src/isEmpty'
import complement from 'ramda/src/complement'

function * getManFromPath(manPath) {
  const { cameraModels } = yield select(cameraModelsSelector)
  const camera = cameraModels.find(cam => cam.manufacturer_path.toLocaleUpperCase('en') === manPath.toLocaleUpperCase('en'))

  if (camera) {
    return camera.manufacturer_path
  } else {
    if (complement(isEmpty)(manPath)) window.history.pushState({}, document.title, '/')
    return null
  }
}

export default pipe(
  defaultTo(''),
  replace(/\//, ''),
  getManFromPath
)



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/getManufacturerFromPath.js